import { ADD_LIFE_COLLECTIONS,REMOVE_LIFE_NEW_BENEFICIARY,SET_COLLECTION_TO_SCHEDULE,SET_LIFE_ACTIVE_BENEFICIARY_ID,SET_LIFE_ACTIVE_BENEFIT_ID, SET_LIFE_BANKING_DETAILS, SET_LIFE_COLLECTIONS, SET_LIFE_COLLECTIONS_LOADING,SET_LIFE_CONTACT, SET_LIFE_ENTITY_METADATA, SET_LIFE_NEW_BENEFICIARY, SET_LIFE_POLICY,SET_LIFE_POLICY_DEBIT_DAY,SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY, SET_LIFE_SPECIAL_DEBIT_DAYS,UPDATE_LIFE_BENEFICIARY,UPDATE_LIFE_CONTACT, UPDATE_LIFE_ENTITY_METADATA, UPDATE_LIFE_POLICY_BENEFITS, UPDATE_LIFE_PREMIUM_PAYER } from '../constants/constants';


export interface LifeBeneficiary {
    id: string;
    name: string;
    bankingDetailId: string;
    bankingDetails: LifeBankingDetails;
    benefitId: string;
    phoneNumber: string;
    dateCreated: string;
    dateModified: string;
    email: string;
}

export interface SubProduct extends LifeBenefit {}

export interface Addon extends LifeBenefit {}

export interface LifeBenefit {
    id: string;
    name: string;
    productCode: string;
    dateCreated: string;
    dateModified: string;
    type: 'product' | 'sub_product' | 'addon' | 'enhancement';
    policyId: string;
    beneficiaries: Array<LifeBeneficiary>;
    subProducts: Array<SubProduct>;
    addons: Array<Addon>
}

export interface LifeContact {
    id: string;
    name: string;
    phoneMobile: string;
    phoneHome: string;
    idNumber: string;
    gender: string;
    claimant?: boolean;
    email: string;
    dateCreated: string;
    description: string;
    salutation: string;
    firstName: string;
    lastName: string;
    knownAs: string;
    dateModified: string;
}

export interface LifeBankingDetails {
    id: string;
    name: string;
    accountHolder: string;
    accountType: string;
    accountNumber: string;
    bankName: string;
    branchCode: string;
    parentType: string;
    parentId: string;
    policyId: string;
    policyDebitDay: string;
    valid: boolean;
    ref: string;
    paymentProvider: string;
    requestMandate: boolean;
    showRequestMandate: boolean;
}

export interface LifeCollection {
    id: string;
    name: string;
    amount: string;
    policyId: string;
    status: string;
    actionDate: string;
    isSpecialDebit: boolean;
}

export interface LifePolicy {
    id: string;
    name: string;
    primaryContactId?: string;
    policyHolderId?: string;
    lifeInsuredId?: string;
    startDate: string;
    monthsActive: string;
    debitOrderDueDate: string;
    activeBenefitId?: string;
    bankingDetails?: LifeBankingDetails;
    benefits: Array<LifeBenefit>;
    collections?: Array<LifeCollection>;
    contact: LifeContact;
    premiumPayer: {
        parentId: string;
        parentType: string;
        bankingDetailId: string;
        name: string;
        surname: string;
        email: string;
        phoneNumber: string;
        title: string;
        relationship: string;
        idNumber: string;
        notes: string;
    }
}

interface Metadata {
    loading: boolean;
    success: boolean;
    error: {
        
    }
}


export interface PolicyState { 
    policy: LifePolicy | null;
    metadata: {[entity: string]: Metadata};
    enabled: boolean;
}

const initialState: PolicyState = {
    // Note: This is what enables life changes (sg_integration branch changes)
    enabled: true,
    metadata: {},
    policy: null
}

const lifePolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LIFE_POLICY:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    ...action.payload
                }
            }
            
        case SET_LIFE_COLLECTIONS_LOADING:
            return {
                ...state,
                metadata: {
                    collection: {
                        loading: action.payload,
                    }
                }
            }
            
        case SET_LIFE_CONTACT:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    contact: {
                        ...state.policy?.contact,
                        ...action.payload
                    }
                }
            }
            
        case SET_LIFE_ACTIVE_BENEFIT_ID:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    activeBenefitId: action.payload
                }
            }
            
        case UPDATE_LIFE_POLICY_BENEFITS:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    benefits: action.payload
                }
            }
            
        case SET_LIFE_NEW_BENEFICIARY:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    newBeneficiary: action.payload
                }
            }
            
        case REMOVE_LIFE_NEW_BENEFICIARY:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    newBeneficiary: null,
                }
            }
            
        case SET_LIFE_ACTIVE_BENEFICIARY_ID:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    activeBeneficiaryId: action.payload
                }
            }
            
        case SET_LIFE_POLICY_DEBIT_DAY:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    debitOrderDueDate: action.payload,
                    mandateStatus: 'pending'
                }
            }
            
        case SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    debitOrderDateFriendly: action.payload,
                }
            }
            
        case SET_LIFE_SPECIAL_DEBIT_DAYS:
            return {
                ...state,
                specialDebitDays: action.payload,
            }
            
        case SET_COLLECTION_TO_SCHEDULE:
            return {
                ...state,
                collectionToSchedule: action.payload,
            }
            
        case UPDATE_LIFE_CONTACT:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    contact: {
                        ...state.policy?.contact,
                        ...action.payload
                    }
                }
            }
            
        case UPDATE_LIFE_BENEFICIARY:
            return {
                ...state,
                policy: {
                    
                }
            }
            
        case SET_LIFE_ENTITY_METADATA:
            action.payload.entity = Object.keys(action.payload)[0];
            return {
                ...state,
                metadata: {
                    ...action.payload,
                }
            }

        case UPDATE_LIFE_ENTITY_METADATA:
            const metadata = {};
            for (const key in state.metadata) {
                metadata[key] = state.metadata[key];
            }
            for (const key in action.payload) {
                metadata[key] = { ...state.metadata[key], ...action.payload[key] }
            }
            return {
                ...state,
                metadata,
            }

        case SET_LIFE_BANKING_DETAILS:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    bankingDetails: {
                        ...state.policy?.bankingDetails,
                        ...action.payload
                    }
                }
            }

        case UPDATE_LIFE_PREMIUM_PAYER:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    premiumPayer: {
                        ...state.policy?.premiumPayer,
                        ...action.payload
                    }
                }
            }

        case SET_LIFE_COLLECTIONS:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    collections: [
                        ...action.payload
                    ]
                }
            }
    
        case ADD_LIFE_COLLECTIONS:
            return {
                ...state,
                policy: {
                    ...state.policy,
                    collections: [
                        ...state.policy?.collections ? state.policy?.collections : [],
                        ...action.payload
                    ]
                }
            }

        default:
            return state;
    }
}

export default lifePolicyReducer;